export default __webpack_public_path__ + "static/media/logo_default-light-bg.71d71bce.svg";